<template>
  <div id="_draggable_container_">
    <v-sheet elevation="5">
      <v-toolbar id="_draggable_container_toolbar" dense dark elevation="1" color="#02466b">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closed()">
          <v-icon>mdi-alpha-x-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <div id="_slot_container">
        <slot>
          <span>pass content into the component to use this slot.</span>
        </slot>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Container Title',
    },
    startingXPos: {
      type: String,
      default: '50%',
    },
  },
  data() {
    return {
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      restingTop: 0,
      restingLeft: 0,
      restingBot: 0,
      restingRight: 0,
      visibleWindow: null,
      elmnt: null,
      firstTime: true,
    };
  },
  watch: {
    startingXPos(n) {
      if (this.firstTime) {
        this.elmnt.style.left = n;
        this.elmnt.style.transform = `translate(-${n},-50%)`
      }
      this.firstTime = false;
    }
  },
  mounted() {
    // Make the DIV element draggable:
    this.elmnt = document.getElementById('_draggable_container_');
    this.elmnt.style.left = this.startingXPos;
    this.elmnt.style.top = '50%';
    this.elmnt.style.transform = `translate(-${this.startingXPos},-50%)`
    const elePositioning = this.elmnt.getBoundingClientRect();
    this.restingTop = elePositioning.top;
    this.restingRight = elePositioning.right;
    this.restingBot = elePositioning.bottom;
    this.restingLeft = elePositioning.left;
    this.dragElement();
  },
  methods: {
    closed() {
      this.$emit('closed');
    },
    dragElement() {
      if (document.getElementById(`${this.elmnt.id}toolbar`)) {
        // if present, the toolbar is where you move the DIV from:
        document.getElementById(`${this.elmnt.id}toolbar`).onmousedown = this.dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        this.elmnt.onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      const event = e || window.event;
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = event.clientX;
      this.pos4 = event.clientY;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },
    elementDrag(e) {
      const event = e || window.event;
      event.preventDefault();
      this.visibleWindow = this.elmnt.getBoundingClientRect();
      // calculate the new cursor position:
      this.pos1 = this.pos3 - event.clientX;
      this.pos2 = this.pos4 - event.clientY;
      this.pos3 = event.clientX;
      this.pos4 = event.clientY;
      // set the element's new position:
      this.restingTop = this.elmnt.offsetTop - this.pos2;
      this.restingLeft = this.elmnt.offsetLeft - this.pos1;
      this.restingRight = this.visibleWindow.right;
      this.restingBot = this.visibleWindow.bottom;
      this.elmnt.style.top = `${this.restingTop}px`;
      this.elmnt.style.left = `${this.restingLeft}px`;
    },
    closeDragElement() {
      // stop moving when mouse button is released:
      if (this.restingTop < 0) { this.restingTop = 0; this.elmnt.style.top = '0px'; }
      if (this.restingRight > window.innerWidth) {
        this.restingLeft -= (
          (window.innerWidth - this.restingLeft) + this.elmnt.offsetWidth
        );
        this.elmnt.style.left = `${this.restingLeft}px`;
      }
      if (this.restingLeft < 0) { this.restingLeft = 0; this.elmnt.style.left = '0px'; }
      if (this.restingBot > window.innerHeight) {
        this.restingTop -= (
          (window.innerHeight - this.restingTop) + this.elmnt.offsetHeight
        );
      }
      document.onmouseup = null;
      document.onmousemove = null;
    },
  }
};
</script>

<style lang="scss" scoped>
#_draggable_container_ {
  position: absolute;
  overflow: hidden;
  z-index: 100;
}

#_draggable_container_toolbar {
  cursor: move;
  z-index: 100;
}

#sheet_ele {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#_slot_container {
  height: 100%;
  padding: 1em;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}
</style>
